var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"d-block font-size-14 mb-1"},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('a',{staticClass:"hiperlink-component-link font-size-14",attrs:{"href":_vm.value,"rel":"”noopener noreferer","target":"_blank"}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }